import { alpha } from '@mui/material'
import { Box, Button, Card, Body2, H6 } from '@dhl-ui/components'
import { DeleteIcon } from '@dhl-ui/icons'

export type DangerZoneContent = {
  title: string
  subtitle: string
  value: string
  button: string
  id?: string
}

export interface Props {
  dangerZoneContent: DangerZoneContent
  onClickOpen: () => void
}

export const DangerZoneCard = ({ dangerZoneContent, onClickOpen }: Props) => (
  <Card>
    {/*TODO-DS: Await decision on danger zone bg via Card component
     * also what to do with 'alpha' from mui/material
     */}
    <Box
      sx={({ palette: { error, common } }) => ({
        background: `linear-gradient(0deg, ${alpha(error.main, 0.1)}, ${alpha(error.main, 0.1)}), ${common.white}`,
      })}
    >
      <Card.Header title={dangerZoneContent?.title} />
      <Card.Content>
        <H6>{dangerZoneContent?.subtitle}</H6>
        <Box pt={2}>
          <Body2>{dangerZoneContent?.value}</Body2>
        </Box>
        <Box pt={2}>
          <Button
            data-testid="on-click-open"
            onClick={onClickOpen}
            color="primary"
            variant="contained"
            size="small"
            startIcon={<DeleteIcon />}
          >
            {dangerZoneContent?.button}
          </Button>
        </Box>
      </Card.Content>
    </Box>
  </Card>
)
